export const SET_WISHLIST_LABEL = 'SET_WISHLIST_LABEL';
export const LOAD_THEME_SETTINGS = 'LOAD_THEME_SETTINGS';

export const setWishlistLabel = (label) => {
    return {
      type: SET_WISHLIST_LABEL,
      payload: label
    };
  };


  export const loadThemeSettings = (settings) => {
    return {
      type: LOAD_THEME_SETTINGS,
      payload: settings
    };
  };